import React from "react";
import { computeWordDiff } from "../utils/diffUtils";
import styles from "./DiffView.module.css";

interface DiffViewProps {
  original: string;
  rewritten: string;
  mode?: "full" | "additions-only";
}

export default function DiffView({ original, rewritten, mode = "full" }: DiffViewProps) {
  const segments = computeWordDiff(original, rewritten);

  return (
    <div className={styles.diffContainer}>
      <div className={styles.diffText}>
        {segments.map((seg, idx) => {
          if (seg.type === "unchanged") {
            return (
              <span key={idx} className={styles.unchanged}>
                {seg.text}
              </span>
            );
          }
          if (seg.type === "added") {
            return (
              <span key={idx} className={styles.added}>
                {seg.text}
              </span>
            );
          }
          if (seg.type === "removed") {
            if (mode === "additions-only") {
              return null;
            }
            return (
              <span key={idx} className={styles.removed}>
                {seg.text}
              </span>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
